import Image from 'next/image';
import Link from 'next/link';
import { GoArrowRight } from 'react-icons/go';

const HeroSection = ({
  highlight,
  subheading,
  description,
  image,
  imageAlt,
  primaryButton,
  secondaryButton
}) => {
  return (
    <div className="w-full flex justify-center items-center bg-[#172554] lg:py-28 lg:px-20 py-10 px-10 max-w-[1750px] mx-auto">
      <div className="flex flex-col md:flex-row justify-center items-center lg:justify-between gap-10 mt-16">
        {/* Left section */}
        <div className="lg:w-[50%] w-full flex flex-col gap-y-8">
            <div className='flex flex-col gap-y-4 '>
                <h1 className=" text-white lg:text-[56px] text-2xl font-inter font-extrabold lg:!leading-[130%]">

                    <span className="text-[#046DEB]">{highlight}</span>{" "}
                    {subheading && <span>{subheading}</span>}
                </h1>
                <p className="text-[#FFFFFF] lg:text-lg text-sm font-normal !leading-[135%] ">{description}</p>
            </div>
          
            <div className='flex flex-row gap-4'>
                {primaryButton && (
                <div className='flex justify-center items-center'>
                    {primaryButton.onClick ? (
                        <button
                            onClick={primaryButton.onClick}
                            type="button"
                            className="text-white bg-[#046DEB] border-2 border-[#046DEB] md:font-medium font-normal rounded-full sm:text-xs lg:text-base lg:px-8 lg:py-3 px-6 py-2 text-center transition-all duration-200 hover:bg-[#0056c7] hover:border-[#0056c7] hover:shadow-lg focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#058BF0]/50 focus-visible:ring-offset-2"
                        >
                            {primaryButton.text}
                        </button>
                    ) : (
                        <Link href={primaryButton.href} className="focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#058BF0]/50 focus-visible:ring-offset-2 rounded-full inline-block">
                        <button
                            type="button"
                            className="text-white bg-[#046DEB] border-2 border-[#046DEB] md:font-medium font-normal rounded-full sm:text-xs lg:text-base lg:px-8 lg:py-3 px-6 py-2 text-center transition-all duration-200 hover:bg-[#0056c7] hover:border-[#0056c7] hover:shadow-lg focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#058BF0]/50 focus-visible:ring-offset-2"
                        >
                            {primaryButton.text}
                        </button>
                        </Link>
                    )}
                </div>
                )}
                {secondaryButton && (
                <div className='flex justify-center items-center'>
                    <a href="#explore" title="Explore Our Services" className="focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#058BF0]/50 focus-visible:ring-offset-2 rounded-full inline-block">
                    <button
                        type="button"
                        className="text-white bg-[#172554] border-2 border-white md:font-medium font-normal rounded-full sm:text-xs lg:text-base lg:px-8 lg:py-3 px-6 py-2 text-center flex items-center justify-center gap-2 transition-all duration-200 hover:bg-white hover:text-[#172554] hover:shadow-lg focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#058BF0]/50 focus-visible:ring-offset-2"
                    >
                        {secondaryButton.text} {secondaryButton.icon && <GoArrowRight className='w-5 h-5' />}
                    </button>
                    </a>
                </div>
                )}
            </div>
        </div>
        {/* Right section */}
        <div className="lg:w-[40%] w-full flex ">
          <div className="relative overflow-hidden w-full h-full rounded-tr-[80px] lg:rounded-tr-[160px]">
            <Image
              src={image}
              alt={imageAlt || 'hero image'}
              className="  w-full object-cover"
            />
            {/* Gradient Overlay */}
            <div className="absolute inset-0 rounded-tr-[80px] lg:rounded-tr-[160px] pointer-events-none z-10 bg-[linear-gradient(0deg,_rgba(30,58,138,0.7)_0%,_rgba(0,0,0,0)_100%)]"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
